export default "__VITE_ASSET__zF45XElT__"